"use client";

/**
 * "Tonight: Champions League Tuesday · 15% off · until 23:59" — the strip
 * the till, the Kitchen board and the website show while a bar night is on.
 * Renders nothing when no night is on.
 */

import { Moon } from "lucide-react";
import type { Id } from "@/convex/_generated/dataModel";
import { clockLabel, dealLabel } from "@/lib/config/nights";
import { useNightsOn } from "@/hooks/useNightsOn";

export function TonightBanner({
  brandId,
  storeId,
  variant = "pos",
  className = "",
}: {
  brandId: Id<"brands"> | string | undefined | null;
  storeId?: Id<"stores"> | string | null;
  /** pos = the admin theme tokens; shop = the storefront's dark strip. */
  variant?: "pos" | "shop";
  className?: string;
}) {
  const { on } = useNightsOn(brandId, storeId);
  if (!on.length) return null;
  const pos = variant === "pos";
  return (
    <div
      className={`flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg px-3 py-2 text-sm ${className}`}
      style={
        pos
          ? { backgroundColor: "rgba(147,51,234,0.12)", color: "var(--admin-text-primary)", border: "1px solid rgba(147,51,234,0.35)" }
          : { backgroundColor: "#111827", color: "#ffffff" }
      }
      role="status"
    >
      <Moon className="w-4 h-4 shrink-0" style={pos ? { color: "var(--admin-accent)" } : { color: "#fbbf24" }} />
      <span className="font-semibold">Tonight</span>
      {on.map((n) => (
        <span key={String(n._id)} className="inline-flex flex-wrap items-center gap-1.5">
          <span className="font-medium">{n.name}</span>
          <span style={pos ? { color: "var(--admin-text-secondary)" } : { color: "rgba(255,255,255,0.8)" }}>
            · {dealLabel(n.deal)}
            {n.tagline ? ` · ${n.tagline}` : ""} · until {clockLabel(n.schedule.endMinutes)}
          </span>
        </span>
      ))}
    </div>
  );
}

export default TonightBanner;
